import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/membershipLengthSagas";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";

const MembershipTypes = () => {
  const dispatch = useDispatch();

  const options = useSelector(
    (state) => state.membershipLengthByAgreement.filters.membership_types
  );
  const selectedFilters = useSelector(
    (state) => state.membershipLengthByAgreement.selectedFilters.membership_types
  );

  return (
    <div className="select-box-no-width" style={{ maxWidth: "140px" }}>
      <p>Membership Type</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedFilters}
        placeholder="Not selected"
        height={324}
        numberDisplayed={0}
        enableOnly
        includeSelectAll
        onSelectChange={(data) =>
          dispatch(actionCreators.updateFilters({ membership_types: data }))
        }
      />
    </div>
  );
};

export default MembershipTypes;
